'use client'

import { useEffect } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { Button } from 'react-vant';
import Header from '@/components/global/Header';
import { ReduxProvider } from '@/components/global/ReduxProvider';
import { matomoSetCustomDimension } from '@/utils/matomoEvent';
import style from '@/styles/global/not-found.module.scss';

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Global error:', error);
    matomoSetCustomDimension(
      29,
      JSON.stringify({
        page: 'global-error',
        message: error?.message || '',
        digest: error?.digest || '',
      }),
    );
  }, [error]);

  return (
    <html lang="en">
      <body>
        <ReduxProvider>
          <Header />
        </ReduxProvider>
        <div className={style['page-not-found']}>
          <Image
            src="https://img.bestdeals.co.nz/images/next/images/404.png"
            width={293}
            height={165}
            className={style['not-found-icon']}
            alt="page-not-found"
          />

          <div className={style['title']}>Oh No !</div>

          <div className={style['sub-title']}>
            Sorry, this item is no longer available.<br></br>
            Please explore similar products you might like.
          </div>

          <Link href="/">
            <Button
              type="primary"
              className={style['continue-btn']}
              style={{
                fontWeight: '700',
                margin: '0 auto 20px auto',
              }}
              block
            >
              Continue Shopping
            </Button>
          </Link>
        </div>
      </body>
    </html>
  );
}
